export const GET_TRANSACTIONS_LIST = 'GET_TRANSACTIONS_LIST'
export const GET_TRANSACTIONS_LIST_SUCCESS = 'GET_TRANSACTIONS_LIST_SUCCESS'
export const GET_LIST_STATUS = 'GET_LIST_STATUS'
export const GET_LIST_STATUS_SUCCESS = 'GET_LIST_STATUS_SUCCESS'
